module.exports = __webpack_public_path__ + "media/images/coming-soon/Coming Soon@2x-76d6e4542a8089341fda9d7dc1758be1.png";